const Prompts = {
    sentences: {
        Fantasy: [
            'A [ADJ] [NOUN] goes on a quest to find a [NOUN]',
            'For centuries, an [ADJ] town has honored the tradition of revering [NOUN]',
            'A [ADJ] [NOUN] embarks on a quest to [VERB] a [ADJ] [NOUN]'
        ],
        Adventure: [
            'A [ADJ] [NOUN] must uncover the secret of the [ADJ] [NOUN]',
            'A [ADJ] [NOUN] is [VERB] by a troupe of [ADJ] [NOUN]s',
            'A [ADJ] [NOUN] finds a [ADJ] [NOUN], and finds themself in a battle between [NOUN]s and [NOUN]s'
        ],
        Educational: [
            'A group of [ADJ] [NOUN]s learn the importance of [NOUN]',
            'An informative overview of the science behind [NOUN]',
            'A Public Service Announcement warning about the dangers of [NOUN]'
        ],
        Misc: [
            'A [ADJ] [NOUN] haunts a group of unsuspecting [NOUN]s',
            'A [ADJ] detective solves the case of the [ADJ] [NOUN]',
            'In the year 3032, [NOUN] has become obselete, being replaced by a series of [ADJ] [NOUN]s'
        ]
    },
    nouns: {
        Fantasy: [
            'Knight', 'Prince', 'Gauntlet', 'Dragon', 'Lord', 'Wizard'
        ],
        Adventure: [
            'Adventurer', 'General', 'Militia', 'Army', 'Pirate', 'Treasure', 'Archeologist', 'Doctor'
        ],
        Educational: [
            'Hygiene', 'Chemistry', 'Body', 'Computer Science', 'Candy', 'Doctor', 'Child', 'Class'
        ],
        Misc: [
            'Fish', 'Flower', 'Plant', 'Men', 'Women'
        ]
    },
    verbs: [
        'Fight', 'Conquer', 'Vanquish', 'Help', 'Assist', 'Build', 'Assert'
    ],
    adjectives: [
        'Dastardly', 'Benevolent', 'Mediocre', 'Ancient', 'Brilliant', 'Moronic'
    ]
}

export default Prompts